import { useParams } from 'react-router-dom';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import { SmartReplyFlowContainer } from '../../components/Settings/Ai/SmartReply/FlowDiagram/SmartReplyFlowContainer';

export default function AiSmartReplyFlowPage() {
    const { planId } = useParams<{ planId?: string }>();
    return (
        <PageMain pageTitle="Build Smart Reply" showError={false} showLoading={false}>
            <div className="settingsPage">
                <SmartReplyFlowContainer planId={planId ? +planId : 0} />
            </div>
        </PageMain>
    );
}
